import { CheckCircle2 } from 'lucide-react';

const benefits = [
  'Predictable investment with no surprises',
  'Access to a network of seasoned security leaders',
  'Flexible engagement - scale up or down as needed',
  'Board-ready reporting and stakeholder communication',
  'Rapid deployment to meet your timeline',
  'Industry-specific expertise across multiple sectors',
];

const WhyUs = () => {
  return (
    <section id="why-us" className="py-24 bg-white">
      <div className="container-custom">
        <div className="text-center mb-16 animate-fade-up">
          <span className="text-xs font-medium text-secondary tracking-[0.2em] uppercase">
            Why Choose Us
          </span>
          <div className="mx-auto mt-4 mb-5 h-px w-12 bg-secondary/40" />
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground tracking-tight mb-4">
            Security Leadership That <span className="text-gradient-teal">Fits Your Business</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-3xl mx-auto">
            Not every business needs a full-time CISO, but every business needs cybersecurity
            leadership. We bridge that gap with experienced professionals who understand both
            security and business.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="animate-fade-up max-w-lg mx-auto lg:mx-0">
            <ul className="space-y-4">
              {benefits.map((benefit, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 animate-fade-up"
                  style={{ animationDelay: `${i * 0.08}s` }}
                >
                  <CheckCircle2 className="h-5 w-5 text-secondary mt-0.5 flex-shrink-0" />
                  <span className="text-foreground">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          <div
            className="grid grid-cols-2 gap-6 animate-fade-up"
            style={{ animationDelay: '0.15s' }}
          >
            <div className="p-6 rounded-xl bg-card border border-border border-t-2 border-t-teal text-center hover:shadow-md hover:shadow-teal/5 transition-all duration-300">
              <div className="text-2xl font-heading font-bold text-secondary mb-2">
                Cost Savings
              </div>
              <div className="text-sm text-muted-foreground">vs full-time hire</div>
            </div>
            <div className="p-6 rounded-xl bg-card border border-border border-t-2 border-t-teal text-center hover:shadow-md hover:shadow-teal/5 transition-all duration-300">
              <div className="text-2xl font-heading font-bold text-secondary mb-2">Fast</div>
              <div className="text-sm text-muted-foreground">time to deploy</div>
            </div>
            <div className="p-6 rounded-xl bg-card border border-border border-t-2 border-t-teal text-center hover:shadow-md hover:shadow-teal/5 transition-all duration-300">
              <div className="text-2xl font-heading font-bold text-secondary mb-2">Retention</div>
              <div className="text-sm text-muted-foreground">long-term clients</div>
            </div>
            <div className="p-6 rounded-xl bg-card border border-border border-t-2 border-t-teal text-center hover:shadow-md hover:shadow-teal/5 transition-all duration-300">
              <div className="text-2xl font-heading font-bold text-secondary mb-2">24/7</div>
              <div className="text-sm text-muted-foreground">incident support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
